import * as Yup from "yup";

export const formValidationSchema = () =>
  Yup.object().shape({
    namaItem: Yup.string().required("Masukan nama item sumber daya"),
    idSatuan: Yup.string().required("Pilih satuan"),
    idKategori: Yup.string().required("Pilih kategori"),
  });
